import FacilityEditFormComponent from './facility-edit-form-component';
import FacilityEditFormService from './facility-edit-form-service';

/***
 * the sub-page within the Client Edit page that contains a form for editing Facility settings.
 */
const facilityEditForm = angular
  .module('FacilityData.ClientEdit.FacilityEditForm', [])
  .component('facilityEditForm', FacilityEditFormComponent)
  .service('FacilityEditFormService', FacilityEditFormService)
  .config(($stateProvider) => {
    'ngInject';

    $stateProvider.state('app.client-edit.facility', {
      url: 'facility/:facilityId/',
      component: 'facilityEditForm',
      resolve: {
        facility: ($stateParams, CommonRequest) => CommonRequest.getFacilityDetails($stateParams.facilityId),
        facilityFields: (FacilitySettings) => FacilitySettings.getFacilityFields(),
        facilitySettings: ($stateParams, FacilitySettings) => FacilitySettings.getFacilitySettings($stateParams.facilityId),
        practitionerList: ($stateParams, CommonRequest, CurrentUser) => {
          return [];
        },
      },
    });
  }).name;

export default facilityEditForm;



// WEBPACK FOOTER //
// ./app/components/client-edit/facility-edit-form/facility-edit-form.js